module.exports = __webpack_public_path__ + "static/media/newarrival_img.51731425.jpg";